import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import SideNavigationBar from "components/SidebarNav/Sidebar";
import TopNavigationBar from "components/navbars/NavigationBar";
import Footer from "components/footer";
import { ProtectedRoute } from "components/ProtectedRoute";
import AdminRoutes from "components/RouteComponent/AdminRoutes";
// pages
import LoginPage from "views/login/LoginPage";
import UserPage from "views/users/UserPage";
import CreateUserPage from "views/users/CreateUserPage";
import RolesPage from "views/role/RolePage";
import ForgotPassword from "views/login/ForgotPassword";
import HomePage from "views/login/HomePage";
import SearchProductPage from 'views/searchProduct/SearchProductPage';
import FavoritesPage from "views/login/FavoritesPage";
import ExportPage from "views/login/ExportPage";
import Workplace from "views/users/Workplace";
import Account from "views/users/Account";
import HelpSupport from "views/users/HelpSupport";
import HistoryPage from "views/users/HistoryPage";
import ChatterPage from "views/login/ChatterPage";
import SubscriptionPage from "views/users/SubscriptionPage";
import CreateSubscription from "views/users/CreateSubscription";
import PaymentPage from 'views/Payment/PaymentPage';
import PaymentTransaction from "views/Payment/PaymentTransaction";
import CreditUsagePage from "views/users/CreditUsagePage";
import PricingModelPage from "views/users/PricingModelPage";
import CreatePricingModel from "views/users/CreatePricingModel";
import ReferralPage from "views/users/ReferralPage";
// import SignUpPage from "views/users/SignUpPage";
import SignUpPage from "views/signup/SignupPage";

import ContactPage from "views/contact/ContactPage";
const CreateUserPageWrapper = props => {
    return <CreateUserPage {...props} />;
};

const CreateSubscriptionWrapper = props => {
    return <CreateSubscription {...props} />;
};

const CreatePricingModelWrapper = props => {
    return <CreatePricingModel {...props} />;
};

export const RouterComponent = withRouter(({ location, history }) => {

    const isPublicPage =
        location.pathname === "/login-page" ||
        location.pathname === "/signup-page" ||
        location.pathname === "/forget-password" ||
        location.pathname === "/contact-us" ||
        location.pathname.startsWith("/create-password") ||
        location.pathname.startsWith("/referral-signup");

    // Pages where the footer should be hidden
    const hideFooter = isPublicPage || location.pathname === "/personalize-modal";

    return (
        <div className="app-container">
            <div className="header-container top-navigation-bar-container">
                <TopNavigationBar history={history} hideActions={isPublicPage} transparent={isPublicPage} />
            </div>
            <div className="side-navigation-bar-container">
                {!isPublicPage && <SideNavigationBar history={history} />}
            </div>
            <div className="main-container">
                <Switch>
                    <Route path="/login-page" render={(props) => <LoginPage {...props} />} />
                    <Route path="/signup-page" render={(props) => <SignUpPage {...props} />} />
                    <Route path="/referral-signup/:referredCode/:emailId" render={(props) => <SignUpPage {...props} />} />
                    <Route path="/forget-password" render={(props) => <ForgotPassword {...props} />} />
                    <Route path="/create-password/:emailId" render={(props) => <ForgotPassword {...props} />} />
                    <Route path="/contact-us" render={(props) => <ContactPage {...props} />} />
                    <AdminRoutes path="/user-page" component={UserPage} />
                    <AdminRoutes path="/create-user-page" component={CreateUserPageWrapper} />
                    <AdminRoutes path="/roles-page" component={RolesPage} />
                    <ProtectedRoute exact path="/home-page" component={(props) => <HomePage {...props} />} />
                    <ProtectedRoute exact path='/search-product' component={SearchProductPage} />
                    <ProtectedRoute exact path="/favourite-page" component={(props) => <FavoritesPage {...props} />} />
                    <ProtectedRoute exact path="/chatt-page" component={(props) => <ChatterPage {...props} />} />
                    <ProtectedRoute exact path="/export-page" component={(props) => <ExportPage {...props} />} />
                    <ProtectedRoute exact path="/workplace" component={(props) => <Workplace {...props} />} />
                    <ProtectedRoute exact path="/credit-usage" component={(props) => <CreditUsagePage {...props} />} />
                    <ProtectedRoute exact path="/subscription" component={(props) => <SubscriptionPage {...props} />} />
                    <AdminRoutes path="/create-subscription-page" component={CreateSubscriptionWrapper} />
                    <ProtectedRoute exact path="/pricing-model" component={(props) => <PricingModelPage {...props} />} />
                    <AdminRoutes path="/create-pricing-page" component={CreatePricingModelWrapper} />
                    <ProtectedRoute exact path="/referral-page" component={(props) => <ReferralPage {...props} />} />
                    <ProtectedRoute exact path="/account" component={(props) => <Account {...props} />} />
                    <ProtectedRoute exact path="/help-support" component={(props) => <HelpSupport {...props} />} />
                    <ProtectedRoute exact path="/history" component={(props) => <HistoryPage {...props} />} />
                    <ProtectedRoute exact path='/payment/pay' component={(props) => <PaymentPage {...props} />} />
                    <ProtectedRoute exact path="/payment/transactions" component={(props) => <PaymentTransaction {...props} />} />
                    <Redirect
                        to={{
                            pathname: "/login-page",
                            state: {
                                from: location
                            }
                        }}
                    />
                </Switch>
            </div>
            {!hideFooter && (
                <div className="footer-container">
                    <Footer />
                </div>
            )}
        </div>
    );
});